import { render, staticRenderFns } from "./StorageForm.vue?vue&type=template&id=a85396da"
import script from "./StorageForm.vue?vue&type=script&lang=js"
export * from "./StorageForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports